import React, { useEffect } from "react";
import styled from "styled-components";
import { RouteComponentProps, withRouter } from "react-router";
import {
  Modal,
  ModalHeader,
  ModalProps,
} from "@sonder/ui/source/styled/components/Modal";
import { Button } from "@sonder/ui/source/styled/fragments/Button";
import { InputField } from "@sonder/ui/source/styled/fragments/InputField";
import { InputGroup } from "@sonder/ui/source/styled/fragments/InputGroup";
import {
  ModalFooter,
  Modal as ModalFragment,
  ModalHeader as ModalHeaderFragment,
} from "@sonder/ui/source/styled/fragments/Modal";
import { PrimaryButton } from "@sonder/ui/source/styled/fragments/PrimaryButton";
import { colors, sizes } from "@sonder/ui/source/styled/theme";
import { CreateTaskModalStateInput } from "tasks/actions";
import { useCreateTaskForm } from "tasks/hooks/useCreateTaskForm";

const StyledModal = styled(Modal)`
  align-items: flex-start;

  ${ModalFragment} {
    background-color: ${colors.grayF};
    margin: 3.75rem auto;
    min-width: 90vw;
    padding: 0;

    @media screen and (min-width: ${sizes.minBreakpoint}) {
      max-width: 40rem;
      min-width: 40rem;
      width: auto;
    }
  }
  ${ModalHeaderFragment} {
    background-color: ${colors.white};
    border-radius: 0.3rem 0.3rem 0 0;
    margin: 0;
    padding: 1.71rem 1.71rem 1rem;
  }
  ${ModalFooter} {
    box-sizing: border-box;
    padding: 0.5rem 1.71rem 1.71rem;
  }

  ${InputField} {
    background-color: transparent;
  }
`;

const Content = styled.div`
  background-color: ${colors.grayF};
  padding: 1rem 1.71rem 1rem;
`;
interface CreateTaskModalProps
  extends Pick<ModalProps, "isOpen" | "onClose">,
    RouteComponentProps,
    CreateTaskModalStateInput {}

export const CreateTaskModal = withRouter(
  ({
    history,
    isOpen,
    onClose,
    subjectId,
    subjectType,
    taskType,
  }: CreateTaskModalProps) => {
    const {
      isBulkSubject,
      isCreateDisabled,
      isCreating,
      isSingleSubject,
      formState,
      onReset,
      onSubmit,
      setFormState,
      FormFields,
    } = useCreateTaskForm({ subjectId, subjectType, taskType });

    useEffect(() => {
      if (isOpen) onReset();
    }, [isOpen]);

    return (
      <StyledModal isOpen={isOpen} onClose={onClose}>
        {({ closeModal }) => (
          <>
            <ModalHeader title={FormFields.Title} onClose={closeModal} />
            {FormFields.Header}
            <Content>
              {FormFields.Content}
              {FormFields.Error}
            </Content>
            <ModalFooter>
              <InputGroup>
                <Button
                  disabled={isCreateDisabled}
                  type="button"
                  onClick={() =>
                    setFormState({
                      ...formState,
                      isDispatching: !formState.isDispatching,
                    })
                  }
                >
                  {formState.isDispatching ? "Back" : "Assign"}
                </Button>
                <PrimaryButton
                  disabled={isCreateDisabled}
                  type="submit"
                  onClick={() =>
                    onSubmit(taskOrJobId => {
                      // CGS Agents do not have access to the CreateTaskModal, so we can just redirect to /tasks
                      if (isBulkSubject) history.push(`/tasks`);
                      if (isSingleSubject)
                        history.push(`/tasks/${taskOrJobId}`);
                      closeModal();
                    })
                  }
                >
                  {(isCreating && "Creating...") || "Create"}
                </PrimaryButton>
              </InputGroup>
            </ModalFooter>
          </>
        )}
      </StyledModal>
    );
  },
);
